export const formatLocalDateTime = (date = new Date()) => {
  const pad = (n) => String(n).padStart(2, "0");
  return (
    `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ` +
    `${pad(date.getHours())}:${pad(date.getMinutes())}`
  );
};

export const getTimezone = () =>
  Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";